import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {InvoiceDealer} from '../../../Models/InvoiceDealer';
import {Grid} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {DealersService} from '../../../Services/dealers.service';
import {UserTerm} from '../../../Models/UserTerm';
import {IButton} from '../../../../shared/card/card.component';


@Component({
  selector: 'app-dealer-overview',
  templateUrl: './billing-accounts-overview.component.html',
  styleUrls: ['./billing-accounts-overview.component.scss']
})
export class BillingAccountsOverviewComponent implements OnInit {

  public grid: Grid;
  public companyName: string;
  public advancedButtons: IButton[] = [];

  @ViewChild('usersRowDetail', {static: false}) usersRowDetail: any;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(private router: Router, private dealersService: DealersService, private translateService: TranslateService,
              private broadCastService: BroadcastService) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.invoice_dealer.dealer_number',
          prop: 'debtor',
          sortable: true,
          type: TextColumn.type,
          width: 130,
          minWidth: 130,
          maxWidth: 130,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.companyName',
          prop: 'companyName',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          responsiveHideCallback: (width) => width < 1024
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.contact',
          prop: 'contact',
          sortable: true,
          type: TextColumn.type,
          width: 150,
          minWidth: 130,
          maxWidth: 250,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.email',
          prop: 'companyEmail',
          sortable: true,
          type: TextColumn.type,
          translate: true
        },
        <TextColumn>{
          name: 'doctrine.invoice_dealer.phone',
          prop: 'phone',
          sortable: true,
          type: TextColumn.type,
          width: 130,
          minWidth: 130,
          maxWidth: 200,
          translate: true
        },
        <ActionColumn>{
          width: 150,
          minWidth: 150,
          maxWidth: 150,
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('back-office/crm/billing-account/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light '
            },
          ]
        }
      ],
      service: this.dealersService,
      rememberURL: this.router.url,
      method: 'getBillingAccounts',
      defaultSort: 'debtor',
      rowDetailTemplate: this.usersRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true
    };
  }
  calFunction(method: string) {
    this[method]();
  }

}
